<template>
    <card minify="true">
        <card-header>
            <card-overline>
                <translate>Details zur Anfrage</translate>
            </card-overline>
        </card-header>
        <card-content>
            <description-group grid="true">
                <description-element :caption="askForQuote.project_name" :title="this.$gettext('Projekttitel')"/>
                <description-element :caption="askForQuote.internal_ask_number"
                                     :title="this.$gettext('Interne Anfragenr.')"/>
                <description-element :caption="askForQuote.delivery_date" isDate="true"
                                     :title="this.$gettext('Wunschliefertermin')"/>
                <description-element :caption="askForQuote.internal_article_number"
                                     :title="this.$gettext('Interne Artikelnr.')"/>
                <description-element :caption="askForQuote.created_at" isDate="true"
                                     :title="this.$gettext('Anfragedatum')"/>
            </description-group>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
export default {
    name: 'ComponentSidebarInquiry',
    components: {DescriptionGroup, DescriptionElement, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
};
</script>
